import { useContext, useEffect, useRef } from "react";
import olMap from "ol/Map";
import MapContext from "../map/MapContext";

export interface ViewResolutionEndProps {
  onResolutionEnd: (zoom: number) => void;
}

const ViewResolutionEnd = ({ onResolutionEnd }: ViewResolutionEndProps) => {
  const map = useContext(MapContext) as olMap;

  const onResolutionEndRef = useRef(onResolutionEnd);
  useEffect(() => {
    onResolutionEndRef.current = onResolutionEnd;
  }, [onResolutionEnd]);

  useEffect(() => {
    if (!map) return;

    const handler = () => {
      const zoom = map.getView().getZoom();
      if (zoom !== undefined) {
        onResolutionEndRef.current(zoom);
      }
    };

    map.on("moveend", handler);
    return () => {
      map.un("moveend", handler);
    };
  }, [map]);

  return null;
};

export default ViewResolutionEnd;
